import type { SignupRequestPayload, SignupResponse } from '@weft/api-definition';
import { SignupResponseSchema } from '@weft/api-definition';
import type { UseMutationOptions } from 'react-query';
import { useMutation } from 'react-query';
import { useLocation } from 'react-router-dom';
import { getPublicApi } from '../../services/api';
import { useVyNavigate } from '../use-vy-navigate';

export function useRegister(options?: UseMutationOptions<SignupResponse, unknown, SignupRequestPayload>) {
  const navigate = useVyNavigate();
  const { state } = useLocation();

  return useMutation({
    mutationFn: async ({ token, password }) => {
      const api = getPublicApi();

      const signupResponse = await api.signup({
        signupRequest: {
          token,
          password,
        },
      });

      return SignupResponseSchema.parse(signupResponse satisfies SignupResponse);
    },
    onSuccess: () => {
      const path = state?.from?.pathname ?? '/';
      navigate(path);
    },
    ...options,
  });
}